import { useAuth } from "../../auth/context";
import config from "../../config";
import { findHealthCenterConfig } from "../healthCenterConfig";

/**
 * Short display name for the doctor's current health center (e.g. "IAF" instead of
 * "Instituto Alexander Fleming"), configured per healthCenterId alongside `rules` in
 * REACT_APP_HEALTH_CENTERS_RULES. Only doctors create orders, so this keys off
 * profile.healthCenter only (myHealthCenter is assistant-only and doesn't apply here) —
 * matching how the API resolves healthCenterId for `mappedToCurrentHC`.
 * Returns null when there's no alias configured (no fallback to a full name).
 */
export default () => {
  const { user } = useAuth();
  const healthCenterId = user.profile?.healthCenter?.id;
  return findHealthCenterConfig(config.healthCentersRules, healthCenterId)?.alias ?? null;
};
